module.exports = __webpack_public_path__ + "media/images/homepage-gina-65fac1116887fa57a112fdf64a38d314.png";